import { UserToolbar } from './user-toolbar.comp';
import { renderCompAndReturnUnmount } from '../utils';
export function renderUserToolbarAndReturnUnmount(elem, props) {
    return renderCompAndReturnUnmount(elem, UserToolbar, props);
}
//# sourceMappingURL=user-toolbar-renderer.js.map